let MaitlandKeyBoard;

import './style.css';

import createReactClass from 'create-react-class';
import React from 'react';
import BindingMixin from '../../../../mixins/binding-mixin';
import ButtonGroup from '../../../form/button-group';
import Keyboard from '../../keyboard';
import { QuickPickContainer } from '../container';

export default (MaitlandKeyBoard = createReactClass({
  displayName: 'MaitlandKeyBoard',
  mixins: [BindingMixin],

  getInitialState() {
    return {
      tab: 'Manipulations',
      keys: {
        Manipulations: 'ΑΒΔΕΖΗΙΚΛΜΝΞΟΠΡΣΤΥΧΨΩΪ',
        Quickwords: 'ΫάέήίΰβγζηθςυχψωϊϋόύώЁ',
        Misc: 'ικλμνξορЂЃЄЇЈЅІ'
      },
      selected: 'main',
      transition: 'slide-right'
    };
  },

  render() {
    return (
      <div onFocus={(e) => e.preventDefault()} onMouseDown={(e) => e.preventDefault()}>
        <QuickPickContainer
          title="Maitland Keyboard"
          {...this.props}
          {...this.state}
          closeButton={true}
          onRequestClose={this.close}
          onClick={this.onClick}
          onTab={this.onTab}
        >
          <div>
            <div className="maitland-keyboard">
              <div className="tabs">
                <ButtonGroup
                  {...this.bind('tab')}
                  src={Object.keys(this.state.keys)}
                  display="list"
                />
              </div>
              <div className="tab-content">
                <Keyboard
                  keys={this.state.keys[this.state.tab]}
                  className="maitland"
                  onClick={this.onClick}
                />
              </div>
            </div>
          </div>
        </QuickPickContainer>
      </div>
    );
  },

  shouldComponentUpdate(props, state) {
    return this.state.tab !== state.tab;
  },

  onClick(key) {
    return this.props.onClick != null ? this.props.onClick.call(this, key) : undefined;
  },

  onTab(idx) {
    return this.setState({ tab: parseInt(idx) });
  },

  close() {
    return this.props.close();
  }
}));
